webpackJsonp([106145348925165],{

/***/ 1369:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BoardingCageInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"boardingWardId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"maxWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"minWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"position","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"species","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-boarding-cage-input-c7aecfd8fc5b6e3ed325.js